export const actionTypes = {
  SET_ACCOUNT_NUMBER: 'SET_ACCOUNT_NUMBER',
  SET_TOKEN: 'SET_TOKEN',
  SET_AUTH_IN_PROGRESS: 'SET_AUTH_IN_PROGRESS',
  SET_AUTH_COMPLETED: 'SET_AUTH_COMPLETED',
};

export const setAccountNumber = (accountNumber) => ({
  type: actionTypes.SET_ACCOUNT_NUMBER,
  accountNumber,
});

export const setTokenAction = (token) => ({
  type: actionTypes.SET_TOKEN,
  token,
});

export const setAuthInProgressAction = () => ({
  type: actionTypes.SET_AUTH_IN_PROGRESS,
});

export const setAuthCompletedAction = () => ({
  type: actionTypes.SET_AUTH_COMPLETED,
});
